import React, { useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';

const districts = [
    'Bagerhat','Bandarban','Barguna','Barishal','Bhola','Bogra','Brahmanbaria','Chandpur',
    'Chapainawabganj','Chattogram','Chuadanga',"Cox's Bazar",'Cumilla','Dhaka','Dinajpur',
    'Faridpur','Feni','Gaibandha','Gazipur','Gopalganj','Habiganj','Jamalpur','Jashore',
    'Jhalokathi','Jhenaidah','Joypurhat','Khagrachari','Khulna','Kishoreganj','Kurigram',
    'Kushtia','Lakshmipur','Lalmonirhat','Madaripur','Magura','Manikganj','Meherpur',
    'Moulvibazar','Munshiganj','Mymensingh','Naogaon','Narail','Narayanganj','Narsingdi',
    'Natore','Netrokona','Nilphamari','Noakhali','Pabna','Panchagarh','Patuakhali',
    'Pirojpur','Rajbari','Rajshahi','Rangamati','Rangpur','Satkhira','Shariatpur',
    'Sherpur','Sirajganj','Sunamganj','Sylhet','Tangail','Thakurgaon'
];

const PreOrderModal = ({ isOpen, onClose }) => {
    const [form, setForm] = useState({ hotelName: "", owner: "", contactPerson: "", contactNumber: "", district: "", domain: "no" });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/preorder`, form);
            toast.success('Pre-order submitted successfully!');
            onClose();
            setForm({ hotelName: "", owner: "", contactPerson: "", contactNumber: "", district: "", domain: "no" });
        } catch (err) {
            console.error(err.response || err);
            toast.error('Failed to submit. Please try again.');
        }
        setLoading(false);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-70">
            <div className="bg-slate-800 p-8 rounded-3xl shadow-2xl w-full max-w-lg text-gray-300 relative">
                <button className="absolute top-4 right-4 text-gray-400 hover:text-white text-2xl" onClick={onClose}>&times;</button>
                <h3 className="text-2xl font-bold mb-4">Pre-Order Our Solution</h3>
                <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
                    <input name="hotelName" placeholder="Hotel Name" value={form.hotelName} onChange={handleChange} className="p-3 rounded-lg bg-gray-900 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" required />
                    <input name="owner" placeholder="Owner" value={form.owner} onChange={handleChange} className="p-3 rounded-lg bg-gray-900 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" required />
                    <input name="contactPerson" placeholder="Contact Person" value={form.contactPerson} onChange={handleChange} className="p-3 rounded-lg bg-gray-900 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" required />
                    <input name="contactNumber" placeholder="Contact Number" value={form.contactNumber} onChange={handleChange} className="p-3 rounded-lg bg-gray-900 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" required />
                    <select name="district" value={form.district} onChange={handleChange} className="p-3 rounded-lg bg-gray-900 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" required>
                        <option value="" disabled>Select District</option>
                        {districts.map(d => <option key={d} value={d}>{d}</option>)}
                    </select>
                    <div className="mb-4">
                        <p className="text-gray-700 font-medium mb-2">Do you have a domain?</p>
                        <div className="flex space-x-6">
                            <label className="flex items-center space-x-2">
                                <input type="radio" name="domain" value="yes" checked={form.domain === "yes"} onChange={handleChange} className="accent-blue-500" />
                                <span>Yes</span>
                            </label>
                            <label className="flex items-center space-x-2">
                                <input type="radio" name="domain" value="no" checked={form.domain === "no"} onChange={handleChange} className="accent-blue-500" />
                                <span>No</span>
                            </label>
                        </div>
                    </div>
                    <button type="submit" className="py-3 bg-blue-600 text-white font-bold rounded-full hover:bg-blue-700 transition transform hover:scale-105" disabled={loading}>
                        {loading ? "Submitting..." : "Confirm"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default PreOrderModal;
